









































































































import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  ITldsProviderData,
  ITldsProviderMethods
} from "@/modules/web_hosting/models/tldsProvider";

@Component({
  components: {
    "product-list-item": () =>
      import("@/components/app/admin/catalogue/products/productListItem.vue")
  }
})
export default class TldsTable extends Vue {
  // Inject

  @Inject({ from: "tldsProviderData" })
  public readonly $tldsProviderData!: () => ITldsProviderData;

  public get tldsData() {
    return this.$tldsProviderData();
  }

  @Inject({ from: "tldsProviderMethods" })
  public readonly tldsMethods!: ITldsProviderMethods;
}
